import { StoryGridSkeleton, StoryTableSkeleton } from "../ui/skeleton";

interface StoriesLoadingStateProps {
    limit: number;
}

export function StoriesLoadingState({ limit }: StoriesLoadingStateProps) {
    return (
        <>
            <div className="hidden md:block">
                <StoryTableSkeleton count={limit} />
            </div>
            <div className="md:hidden">
                <StoryGridSkeleton count={limit} />
            </div>
        </>
    );
}
